import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@bn/auth/services';
import { ENV_CONFIG } from '@bn/primitives';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const envConfig = inject(ENV_CONFIG);
  const authService = inject(AuthService);
  const token = authService.authStoreValue?.auth_token;

  const apiOrigin = new URL(envConfig.apiUrl).origin;
  let reqOrigin: string;
  try {
    reqOrigin = new URL(req.url, location.origin).origin;
  } catch {
    return next(req);
  }

  if (!token || reqOrigin !== apiOrigin) {
    return next(req);
  }

  return next(req.clone({ headers: req.headers.set('Authorization', token) }));
};
